import { apiInstance } from "./ApiInstance";

export const ageingReports = async (payload) => {
  let { data = {} } = await apiInstance.get("/api/case/ageing-report", payload);
  return data;
};
